import FormLabel from "./FormLabel";

const RangeInput = ({
    className,
    InputComponent,
    label,
    startProps,
    endProps,
    ...commonProps
}) => {

    return <div className={className}>
        <div className="d-flex flex-row row">
            <FormLabel className="col-12">{label}</FormLabel>
            <span className="col mt-auto">
                <InputComponent
                    {...startProps}
                    {...commonProps}
                />
            </span>
            <FormLabel className="col-auto mt-auto mb-2 px-0">
                To
            </FormLabel>
            <span className="col mt-auto">
                <InputComponent
                    {...endProps}
                    {...commonProps}
                />
            </span>
        </div>
    </div>
}

export default RangeInput;